/**
  * util function: find if an item is in the list(same Id), if so, return the index
  * @param {Object} item - item to be found
  * @param {list} list - the list to find the item
  * @returns {number} index, if not found, will return -1
  */
export const findItemIndex = (item, list) => {
  if (!item || !list || list.length === 0) {
    return -1;
  }
  for (let i = 0; i < list.length; i += 1) {
    if (item.Id === list[i].Id) {
      return i;
    }
  }
  return -1;
};
